// Mock data for Prayatne website

export const heroSlides = [
  {
    id: 1,
    image: "https://prayatn.org/wp-content/uploads/2025/06/Sharing-Happiness-together-2.jpg",
    alt: "Sharing Happiness together"
  },
  {
    id: 2,
    image: "https://prayatn.org/wp-content/uploads/2025/06/Mr.-Yogesh-Jain-receving-Award.jpg",
    alt: "Mr. Yogesh Jain receiving Award"
  },
  {
    id: 3,
    image: "https://prayatn.org/wp-content/uploads/2025/06/A-word-of-Gratitude.jpg",
    alt: "A word of Gratitude"
  }
];

export const interventions = [
  {
    id: 1,
    title: "Women Empowerment",
    description: "Empowering women through education, skill development, and economic opportunities.",
    link: "/women-empowerment"
  },
  {
    id: 2,
    title: "Child Development",
    description: "Ensuring holistic development of children through education and protection.",
    link: "/child-development"
  },
  {
    id: 3,
    title: "Health & Nutrition",
    description: "Promoting health and nutrition awareness in rural communities.",
    link: "/health-nutrition"
  },
  {
    id: 4,
    title: "Livelihood Development",
    description: "Creating sustainable livelihood opportunities for marginalized communities.",
    link: "/livelihood-development"
  },
  {
    id: 5,
    title: "Water & Sanitation",
    description: "Ensuring access to clean water and sanitation facilities.",
    link: "/water-sanitation"
  },
  {
    id: 6,
    title: "NRM & Climate Change",
    description: "Natural resource management and climate change adaptation strategies.",
    link: "/nrm-climate-change"
  }
];

export const latestNews = [
  {
    id: 1,
    title: "Promoting Safe Beginnings During National Newborn Care Week",
    date: "November 26, 2025",
    category: "Latest Activities",
    image: "https://prayatn.org/wp-content/uploads/2025/11/Group-Photo.jpeg",
    excerpt: "Special programs conducted to promote newborn care awareness."
  },
  {
    id: 2,
    title: "Doorstep Health Awareness on World Diabetes Day",
    date: "November 26, 2025",
    category: "Health Awareness",
    image: "https://prayatn.org/wp-content/uploads/2025/11/Sonbhadra-768x420.jpeg",
    excerpt: "Community health awareness campaigns on World Diabetes Day."
  },
  {
    id: 3,
    title: "Special Dental and Oral Health Check-Up Camps",
    date: "November 26, 2025",
    category: "Health Programs",
    image: "https://prayatn.org/wp-content/uploads/2025/11/1-768x576.jpeg",
    excerpt: "Dental check-up camps conducted in Sonbhadra and Shravasti."
  },
  {
    id: 4,
    title: "German Philanthropists Visit Dholpur",
    date: "November 25, 2025",
    category: "Partnerships",
    image: "https://prayatn.org/wp-content/uploads/2025/11/%F0%9D%97%9A%F0%9D%97%B2%F0%9D%97%BF%F0%9D%97%BA%F0%9D%97%AE%F0%9D%97%BB-%F0%9D%97%A3%F0%9D%97%B5%F0%9D%97%B6%F0%9D%97%B9%F0%9D%97%AE%F0%9D%97%BB%F0%9D%98%81%F0%9D%97%B5%F0%9D%97%BF%F0%9D%97%BC%F0%9D%97%BD%F0%9D%97%B6%F0%9D%98%80%F0%9D%98%81%F0%9D%98%80-%F0%9D%97%A9%F0%9D%97%B6%F0%9D%98%80%F0%9D%97%B6%F0%9D%98%81-%F0%9D%97%97%F0%9D%97%B5%F0%9D%97%BC%F0%9D%97%B9%F0%9D%97%BD%F0%9D%98%82%F0%9D%97%BF-9-768x512.jpg",
    excerpt: "International visitors witness community-led development initiatives."
  }
];

export const impactStories = [
  {
    id: 1,
    title: "Cultivating Change: The Story Behind One Farmer's Double Profits",
    date: "June 18, 2025",
    image: "https://prayatn.org/wp-content/uploads/2025/06/Premanand-Behara-With-Jira-Rice.jpg",
    excerpt: "Padmapada, a small village in the Gop block of Puri District, Odisha, has long relied on agriculture for livelihood."
  },
  {
    id: 2,
    title: "A Village Girl's Journey To Self-Reliance",
    date: "July 22, 2025",
    image: "https://prayatn.org/wp-content/uploads/2025/07/Poster-JPG.jpg",
    excerpt: "Sihuliya is a small, remote village in the Cholapur block of Varanasi, Uttar Pradesh."
  },
  {
    id: 3,
    title: "Light in Everyone's Life",
    date: "June 30, 2021",
    image: "https://prayatn.org/wp-content/uploads/2021/06/PrayatnCaseStudiesImg5.jpg",
    excerpt: "Bringing electricity and hope to remote villages."
  },
  {
    id: 4,
    title: "Jal Minar through Jal Samiti",
    date: "June 30, 2021",
    image: "https://prayatn.org/wp-content/uploads/2021/07/JalMinarImg1.jpg",
    excerpt: "Community-led water management solutions."
  }
];

export const donorLogos = [
  "https://prayatn.org/wp-content/uploads/2021/06/PrayatnDonorPartnerImg1.jpg",
  "https://prayatn.org/wp-content/uploads/2021/06/PrayatnDonorPartnerImg2.jpg",
  "https://prayatn.org/wp-content/uploads/2021/06/PrayatnDonorPartnerImg3.jpg",
  "https://prayatn.org/wp-content/uploads/2021/06/PrayatnDonorPartnerImg4.jpg",
  "https://prayatn.org/wp-content/uploads/2023/04/EMpower-768x436.jpg",
  "https://prayatn.org/wp-content/uploads/2023/04/LICHousing.jpg",
  "https://prayatn.org/wp-content/uploads/2021/06/PrayatnDonorPartnerImg6.jpg",
  "https://prayatn.org/wp-content/uploads/2021/06/PrayatnDonorPartnerImg7.jpg"
];

export const awards = [
  {
    id: 1,
    image: "https://prayatn.org/wp-content/uploads/2025/06/NGO-Leadership-Award-677x1024.jpeg",
    title: "NGO Leadership Award"
  },
  {
    id: 2,
    image: "https://prayatn.org/wp-content/uploads/2023/02/PrayatnAwardImg2.jpg",
    title: "Excellence Award"
  },
  {
    id: 3,
    image: "https://prayatn.org/wp-content/uploads/2022/07/PrayatnAward.jpg",
    title: "Community Service Award"
  },
  {
    id: 4,
    image: "https://prayatn.org/wp-content/uploads/2023/02/PrayatnAwardImg1.jpg",
    title: "Recognition Award"
  },
  {
    id: 5,
    image: "https://prayatn.org/wp-content/uploads/2022/12/COVIDVaccinationCampaignAward-1024x1009.jpg",
    title: "COVID Vaccination Campaign Award"
  },
  {
    id: 6,
    image: "https://prayatn.org/wp-content/uploads/2021/07/Accreditation-by-Charities-Aid-Foundation.jpg",
    title: "Charities Aid Foundation Accreditation"
  }
];

export const whySupportReasons = [
  {
    id: 1,
    title: "Legitimacy and Financial Integrity",
    description: "Due registration under all applicable laws and good compliance record."
  },
  {
    id: 2,
    title: "Credibility",
    description: "ISO 9001:2015 certification and accreditation by Charities Aid Foundation. Awards by Local administration, appreciation by civil society. Long list of international and Indian donor agencies, corporate etc. who have extended us financial support."
  },
  {
    id: 3,
    title: "Wide Coverage",
    description: "Over 2 million lives impacted so far through direct grassroot level intervention. More than 1800 villages, 1300 schools, 900 Anganwadis and Health facilities, 250 brick kilns and 40 urban slums covered across 18 districts of 5 states."
  },
  {
    id: 4,
    title: "Strong Visioning",
    description: "Clear vision of self reliant society guides our working strategy and approach."
  },
  {
    id: 5,
    title: "Effectiveness",
    description: "Policies of 2 states influenced. A district developed as model for child protection. Practical sustainable community based solutions for complex socio-economic issues developed and demonstrated on ground."
  },
  {
    id: 6,
    title: "Result Based Management",
    description: "Stakeholder-wise milestone based planning and monitoring that bring result based management in development sector guiding the working. Strong internal monitoring mechanism to ensure quality and timeliness in working."
  },
  {
    id: 7,
    title: "Innovation",
    description: "Several effective grassroots level micro-innovations developed and demonstrated."
  },
  {
    id: 8,
    title: "Rich Understanding & Experience",
    description: "Working at grassroots level for about 3 decades. Wide range of issues addressed in comprehensive manner meticulously."
  },
  {
    id: 9,
    title: "Rich Human Resource",
    description: "Team about 400 frontline workers and about 40 professionals to guide & support them. In-house training expertise and facilities."
  },
  {
    id: 10,
    title: "Qualitative Documentation & Publication Capacity",
    description: "In-house capacity to prepare wide range of appreciated need based documents and publications."
  },
  {
    id: 11,
    title: "Emergency Response Capacity",
    description: "Experienced in running helplines and undertaking short and long terms relief work during emergency situations like COVID pandemic, cyclones etc."
  }
];